/*
	Questo è per posizionare il link "Vedi altro" al fondo del testo
	troncato con un line-clamp, nella visualizzazione mobile
*/
$('.cutlines-ellipsis').each(function() {
	if (this.scrollHeight > this.clientHeight) {
		let text = $(this).text();

		let modal_id = $(this).attr('data-target');
		let link = $('<a tabindex="0" class="more-text" href="#" data-target="' + modal_id + '">Vedi altro</a>');
		$(this).append(link);

		while(this.scrollHeight > this.clientHeight) {
			text = text.slice(0, -1);
			$(this).empty().text(text + '... ');
			$(this).append(link);
		}
	}
});

$('.cutlines-ellipsis-content').each(function() {
	if (this.scrollHeight > this.clientHeight) {
        let text = $(this).text();
        let link = $('<a tabindex="0" class="more-text-content" href="#"">MOSTRA DI PIÙ</a>');
		$(this).append(link);

        while(this.scrollHeight > this.clientHeight) {
			text = text.slice(0, -1);
			$(this).empty().text(text + '... ');
			$(this).append(link);
		}
	}
});

$('body').on('click', '.more-text-content', (e) => {
    let link = $(e.currentTarget);
    let box = link.closest('.cutlines-ellipsis-content');
    let final = box.attr('data-full-text');
    box.data('data-cut-text', box.html());

    /*
        Per qualche motivo, la funzione css() di jQuery non funziona per
        modificare l'attributo -webkit-line-clamp
    */
    box.get(0).style.cssText = "-webkit-line-clamp: 100;";

    box.empty().text(final).append('<a tabindex="0" class="less-text-content" href="#"">MOSTRA DI MENO</a>');
});

$('body').on('click', '.less-text-content', (e) => {
    let link = $(e.currentTarget);
    let box = link.closest('.cutlines-ellipsis-content');
    let final = box.data('data-cut-text');
    box.get(0).style.cssText = '';
    box.empty().html(final);
});

var list = $('.js-dropdown-list');
var listItems = $('.js-dropdown-list li')
var link = $('.js-link');
var currentSeason = $('.current-season');
link.click(function(e) {
    e.preventDefault();
    list.slideToggle(200);
});

list.find('li').click(function() {
	var text = $(this).html();
    const seasonNumber = $(this).attr('value')
    listItems.removeClass('current');
    $(this).addClass('current');
	currentSeason.html(text);
    list.slideToggle(200);

	$('.season-description').each((i, child) => {
		var c = $(child);
		const season = c.attr('data-season');
		if (season === seasonNumber) {
			c.css('display', 'block');
		}
		else {
			c.css('display', 'none');
		}
	});
});
